import { Navigate, Route, Routes } from "react-router-dom";

import { AppLayout } from "./layouts/app";
import { CartsPage } from "./pages/carts";
import { DashboardPage } from "./pages/dashboard";
import { KeywordsPage } from "./pages/keywords";
import { SeoSlugsPage } from "@/pages/seo-slugs";
import { ZeroResultSearchesPage } from "@/pages/zero-result-searches";
import { LoginPage } from "./pages/login";
import { MarginsPage } from "./pages/margins";
import OrderDetailsPage from "./pages/order-details";
import { PromotionsPage } from "./pages/promotions";
import { ScrapedBrandsPage } from "./pages/scraped/brands";
import { ScrapeCategoriesPage } from "./pages/scraped/categories";
import { ScrapedProductsPage } from "./pages/scraped/products";
import { SuppliersPage } from "./pages/suppliers";
import { UsersPage } from "./pages/users";

import BrandsPage from "@/pages/brands";
import CategoriesPage from "@/pages/categories";
import CountriesPage from "@/pages/countries";
import OrdersPage from "@/pages/orders";
import { ProductsPage } from "@/pages/products";
import StorefrontPage from "@/pages/storefront";

function App() {
  return (
    <Routes>
      <Route element={<LoginPage />} path="/login" />
      <Route element={<AppLayout />}>
        <Route element={<DashboardPage />} path="/dashboard" />
        <Route element={<ProductsPage />} path="/products" />
        <Route element={<CategoriesPage />} path="/categories" />
        <Route element={<BrandsPage />} path="/brands" />
        <Route element={<StorefrontPage />} path="/storefront" />
        <Route element={<CountriesPage />} path="/countries" />
        <Route element={<MarginsPage />} path="/margins" />
        <Route element={<SuppliersPage />} path="/suppliers" />
        <Route element={<OrdersPage />} path="/orders" />
        <Route element={<CartsPage />} path="/carts" />
        <Route element={<PromotionsPage />} path="/promotions" />
        <Route element={<OrderDetailsPage />} path="/orders/:id" />
        <Route element={<UsersPage />} path="/users" />
        <Route element={<KeywordsPage />} path="/keywords" />
        <Route element={<SeoSlugsPage />} path="/seo-slugs" />
        <Route element={<ZeroResultSearchesPage />} path="/zero-result-searches" />
        <Route element={<ScrapedProductsPage />} path="/scraped/products" />
        <Route element={<ScrapeCategoriesPage />} path="/scraped/categories" />
        <Route element={<ScrapedBrandsPage />} path="/scraped/brands" />
      </Route>
      <Route element={<Navigate replace to="/products" />} path="*" />
    </Routes>
  );
}

export default App;
